import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { AppStore, MobileApp } from 'app/modules/main/models/mobile-apps';
import { CustomIcons } from '@shared/models/custom-icons';

type AppPlatform = {
  platform: string,
  apps: AppStore[],
};

@Component({
  selector: 'app-mobile-apps-card',
  templateUrl: './mobile-apps-card.component.html',
  styleUrls: ['./mobile-apps-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileAppsCardComponent {
  private _mobileApp: MobileApp;
  public platforms: AppPlatform[] = [];
  public appIcon = CustomIcons.Links;

  public get mobileApp(): MobileApp {
    return this._mobileApp;
  }

  @Input() public set mobileApp(app: MobileApp) {
    this._mobileApp = app;
    this.platforms = this.groupPlatforms(app);
  }

  public getStoreIcon(platform: string): CustomIcons {
    const iconTypes = {
      'iOS': CustomIcons.Ios,
      'Android': CustomIcons.Android,
      'Windows Phone': CustomIcons.Windows,
    };

    return iconTypes[platform] || CustomIcons.Apps;
  }

  private groupPlatforms(app: MobileApp): AppPlatform[] {
    const platforms = ['Android' ,'iOS', 'Windows Phone'];

    return platforms.reduce((appPlatforms: AppPlatform[], platformName: string) => {
      const apps = app.appStores.filter(store => store.platform === platformName);
      if (apps.length > 0) {
        const appPlatform: AppPlatform = { platform: platformName, apps };
        appPlatforms.push(appPlatform);
      }

      return appPlatforms;
    }, []);
  }
}
